import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React, {useEffect, useState} from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import ReplySharpIcon from '@mui/icons-material/ReplySharp';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import FiberNewIcon from '@mui/icons-material/FiberNew';

import {guestbook, SendNewPost, DeletePost} from './Functions.js';

const NewPost=(props)=>{

	const {SetOpen}=props;

	return (
		<Button
			style={{
				backgroundColor:'#F70', 
			}}
			variant="contained"
			startIcon={<FiberNewIcon />}
			onClick={()=>{
				guestbook['post-id']='new';
				SetOpen(true);
			}}
			>
			Post
		</Button>
	);

}

const Reply=(props)=>{

	const {SetOpen}=props;

	return (
		<Button
			style={{
				backgroundColor:'rgb(25, 118, 210)', 
			}}
			variant="contained"
			startIcon={<ReplySharpIcon />}
			onClick={()=>{
				guestbook['post-id']=props['data-id'];
				SetOpen(true);
			}}
			>
			Reply
		</Button>
	);
}

const Delete=(props)=>{

	const {SetPosts, type, posts}=props;

	const [loading, SetLoading]=useState(false);

	return (
		<LoadingButton 
			loading={loading}
			variant="contained"
			endIcon={<DeleteSharpIcon />}
			onClick={()=>{

				SetLoading(true);

				DeletePost({pid:props['data-id']})

					.then((res)=>{
						if(res.success){
							return res.data;
						}

					}).then(res=>{

						let position,
								NewPosts=[...posts];

						if(type==='post'){
							position=NewPosts.findIndex(x=>x.id===props['data-id']);
							NewPosts.splice(position, 1);

						}else{
							let xpos=[];
							xpos[0]=NewPosts.findIndex(x=>x.id===props['data-parent']);
							xpos[1]=NewPosts[xpos[0]].reply.findIndex(x=>x.id===props['data-id']);
							position=xpos;
							NewPosts[position[0]].reply.splice(position[1], 1);
						}

						SetPosts(NewPosts);

						SetLoading(false);
					});
			}}
			style={{
				backgroundColor:'#C00', 
			}}
			>
			Delete
		</LoadingButton>
	);
}

const Cancel=(props)=>{

	const {loading, disabled, SetOpen}=props;

	const HandleClick=()=>{
		if(loading)return;
		SetOpen(false);
	}

	return (
		<Button
			style={{
				backgroundColor:'#CCC', 
			}}
			variant="contained"
			startIcon={<CancelSharpIcon />}
			onClick={HandleClick}
			disabled={disabled}
			>
			Cancel
		</Button>
	);
}

const Submit=(props)=>{

	const {SetOpen, SetPosts, SetPostID, SendingPost, pid, posts}=props;

	const [loading, SetLoading]=useState(false);

	const Post={
		name	:'', 
		input	:'', 
		type	:pid==='new'?'post':'reply', 
		pid		:pid, 
	};

	const HandleClick=()=>{

		SetLoading(true);

		Post.name=guestbook['new-post'].name;
		Post.input=guestbook['new-post'].input;

		if(Post.input.length>0){

			SendNewPost(Post)
				.then((res)=>{
					if(res.success){
						return res.data;
					}
				}).then(res=>{

					let NewPosts=[...posts]; // =[...posts]: 複製，=posts: 指向

					if(Post.type==='reply'){
						let intIndex=NewPosts.findIndex(x=>x.id===pid);
						if(!NewPosts[intIndex].hasOwnProperty('reply'))NewPosts[intIndex].reply=[];
						NewPosts[intIndex].reply.push(res);
					}else{
						NewPosts=[res].concat(NewPosts);
					}
					SetPosts(NewPosts);

					SetLoading(false);
					// SetPostID(0); // 此變化為 SetOpen 內的子項目，不能在 SetOpen 變更值時一起變更，否則會造成 SetOpen 錯亂
					SetOpen(false);

				});
		}else{ // 未輸入任何內容
			
		}
	}

	/*
	 * 外部導入的 function 也要加到依賴陣列中
	 * 所以應該是 [loading, SendingPost] 而非 [loading]
	 * 否則會出現 React Hook useEffect has a missing dependency: 'SendingPost'
	 * 
	 * 因為 useEffect 中使用了 Sending
	 * 但在 useEffect 的依賴陣列中沒有包含 Sending，這會導致 useEffect 的行為不一致
	 * 而 SetLoading 沒有警告的原因是這個函式是由 useState 返回的
	 * React 能夠確定它不會在渲染之間改變，因此不需要將其添加到 useEffect 的依賴陣列中
	 */
	useEffect(()=>{
		SendingPost(()=>loading);
	}, [loading, SendingPost]);

	return (
		<>
			<Cancel
				disabled={loading}
				{...{loading, SetOpen, SetPostID}}
				/>
			<LoadingButton 
				loading={loading}
				variant="contained"
				endIcon={<SendSharpIcon />}
				onClick={HandleClick}
				disabled={guestbook['new-post'].name.length===0||guestbook['new-post'].input.length===0}
				style={{
					backgroundColor:'#090', 
				}}
				>
				Submit
			</LoadingButton>
		</>
	);

}

const LoadMore=(props)=>{

	const {SetPage, intLoading}=props;

	const [intButtonLoading, SetButtonLoading]=useState(false);

	const HandleClick=()=>{

		SetButtonLoading(true);

		SetPage((prev)=>{ // SetPage((prev)=>prev+1);
			prev++;
			return prev;
		});

	}

	useEffect(()=>{
		if(intLoading===true)return;
		SetButtonLoading(false);
	}, [intLoading]);
	/*
	 * 最後的 [intLoading]
	 * 監聽來自 List 中 intLoading 的值變化，有變化就執行 useEffect
	 */

	return (
		<LoadingButton 
			loading={intButtonLoading}
			variant="contained"
			onClick={HandleClick}
			>
			Load More
		</LoadingButton>
	);
}

const ButtonAction=(props)=>{

	let button;

	switch(props.action){
		case 'submit-post':
		case 'submit-reply':
			button=Submit(props);
			break;
		case 'load-more':
			button=LoadMore(props);
			break;
		case 'reply':
			button=Reply(props);
			break;
		case 'delete':
			button=Delete(props);
			break;
		case 'new-post':
			button=NewPost(props);
			break;
		default:
			button=false;
	}

	return button;

}

export default ButtonAction;